import Repository from "./Repository";

const nbeResource = "nbe/nbeData";
const submitAanvraagNbeResource = "nbe/submitAanvraagNbe";
const saveNbeRequestResource = "nbe/saveNbeRequestProgress";
const saveNbeRequestFilesResource = "nbe/saveNbeRequestFiles";
const nbeProgressResource = "nbe/nbeProgressForUser";
const nbeCancelResource = "nbe/cancelAanvraagNbe";

export default {
  getNbeData() {
    return Repository.post(nbeResource);
  },
  getNbeProgressForUser() {
    return Repository.post(nbeProgressResource);
  },
  cancelNbeAanvraag(aanvraagNbe) {
    return Repository.post(nbeCancelResource, aanvraagNbe);
  },
  submitAanvraagNbe(aanvraagNbe) {
    return Repository.post(submitAanvraagNbeResource, aanvraagNbe).then(
      (res) => {
        return this.saveNbeRequestFilesToDB(aanvraagNbe);
      }
    );
  },
  saveNbeRequestProgressToDB(aanvraagNbe, step) {
    return Repository.post(saveNbeRequestResource, { aanvraagNbe, step }).then(
      (res) => {
        return this.saveNbeRequestFilesToDB(aanvraagNbe);
      }
    );
  },
  saveNbeRequestFilesToDB(aanvraagNbe) {
    const fd = new FormData();
    fd.append("pRequest", aanvraagNbe.pRequest);
    aanvraagNbe.tewerkstellingsGegevensBinnenOnderwijs.forEach((element) => {
      element.tewerkstellingsFiles.forEach((f) => {
        fd.append("files", f);
      });
    });
    aanvraagNbe.tewerkstellingsGegevensBuitenOnderwijs.forEach((element) => {
      element.tewerkstellingsFiles.forEach((f) => {
        fd.append("files", f);
      });
    });
    aanvraagNbe.tewerkstellingsGegevensOpenbaarAmbt.forEach((element) => {
      element.tewerkstellingsFiles.forEach((f) => {
        fd.append("files", f);
      });
    });
    return Repository.post(saveNbeRequestFilesResource, fd);
  },
};
